import React, { PropsWithChildren } from "react";
import { FC, useEffect, useState } from "react";

export type LazyLoaderProps = PropsWithChildren<{
  delay?: number;
}>;

export const LazyLoader: FC<LazyLoaderProps> = ({ delay = 250, children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  return show ? <>{children}</> : null;
};
